/**
 * created by lei lei on 2020/6/12
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MediaInformation from './MediaInformation'
export default class MediaInformationComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <MediaInformation
                    title={'清华学院官方微信'}
                    iconUrl={'https://static-data.eol.cn/upload/logo/140.jpg'}
                    mark={'清华学院'}
                    dateMark={'已超过一个月未发文'}
                    accountNumber={143143213215}
                    customIconWidthHeight={70}
                    colorType={3}
                    keepRecordIconShow={true}
                    onClickFunction={()=>{
                        console.log('点击了某一项')
                    }}
                    onClickBottomFunction={()=>{
                        console.log('点击底部按钮')
                    }}

                />
            </div>
        )
    }

}